export default {"src":"/_next/static/media/farmhouse-bungalows-icon-selected.460ccfd3.svg","height":74,"width":134,"blurWidth":0,"blurHeight":0};